export const SUPPLIER_TYPE = {
  airasia: 'AirAsia',
  coop: 'Coop'
}